import { Box, Skeleton } from '@mui/material';
import { WalletSummaryCard } from 'src/pages/Monitor/components/WalletSummaryCard';
import { CompositionDataItem } from 'src/types/wallet';

import { CompositionCard } from '../../components/CompositionCard';

type FundViewInfoCardsProps = {
  isLoadingComposition: boolean;
  isLoadingSummary: boolean;
  compositionData: CompositionDataItem[];
  fundsCount: number;
  triggeredAlertsCount: number;
  onOpenComposition?: () => void;
};

function SummaryCardSkeleton() {
  return (
    <Skeleton
      variant="rectangular"
      animation="wave"
      width="100%"
      height={140}
      sx={{ borderRadius: 2 }}
    />
  );
}

export function FundViewInfoCards({
  isLoadingComposition,
  isLoadingSummary,
  compositionData,
  fundsCount,
  triggeredAlertsCount,
  onOpenComposition,
}: FundViewInfoCardsProps) {
  return (
    <Box
      width="100%"
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      gap={2}
      px={1}
      pb={2}>
      {isLoadingComposition ? (
        <SummaryCardSkeleton />
      ) : (
        <CompositionCard
          title="Composição"
          compositions={compositionData}
          onClick={onOpenComposition ?? (() => undefined)}
        />
      )}
      {isLoadingSummary ? (
        <SummaryCardSkeleton />
      ) : (
        <WalletSummaryCard
          data={{
            title: 'Total de Fundos',
            description: 'monitorado(s)',
            value: fundsCount,
          }}
        />
      )}
      {isLoadingSummary ? (
        <SummaryCardSkeleton />
      ) : (
        <WalletSummaryCard
          data={{
            title: 'Atenção necessária',
            description: 'alerta(s) disparado(s)',
            value: triggeredAlertsCount,
            ...(triggeredAlertsCount > 0 ? { color: '#ff4747' } : {}),
          }}
        />
      )}
    </Box>
  );
}
